import { useCallback } from 'react';
import { logout } from 'app/api';
import { deleteCookie } from 'app/libs/cookie';
import { useDispatch } from 'react-redux';
import { goHome } from 'app/libs/location';
import { ACCESS_TOKEN_KEY, AUTH_PLATFORM_KEY } from 'app/libs/auth';
import { removeMyInfoAccessData } from 'app/hook/my/useMyInfoAccess';
import { clearWithdrawData } from 'app/libs/withdrawStorageUtils';
import { clearWithdrawCancelSession } from 'app/hook/my/withdraw/useWithdrawCancelSession';
import errors from 'app/constants/errors';
import useEnlog from 'app/hook/common/useEnlog';
import { loggedInFalse } from 'app/store/modules/auth';
import useSsrCookie from 'app/hook/common/useSsrCookie';
import useGoLogin from '../common/useGoLogin';

export const clearAuthInfo = () => {
	deleteCookie('X-Auth-Token-Encar');
	deleteCookie(ACCESS_TOKEN_KEY);
	deleteCookie(AUTH_PLATFORM_KEY);
	deleteCookie('USERID');
	deleteCookie('USERNAME');
	deleteCookie('USERTYPE');
	try {
		removeMyInfoAccessData();
		clearWithdrawData();
		clearWithdrawCancelSession();
	} catch (e) {
		console.error(e);
		console.log(errors.LogMessage.STORAGE_SECURE);
	}
};

function useLogout() {
	const { getCookie } = useSsrCookie();
	const { enloggingJsonData } = useEnlog();
	const goLogin = useGoLogin();
	const dispatch = useDispatch();

	return useCallback(
		async ({ returnUrl = '' } = {}) => {
			try {
				const platform = getCookie('ENID_PLATFORM') || '';
				await logout();
				clearAuthInfo();
				dispatch(loggedInFalse());

				const dataTalkCustom = {
					eventtype: 'ACTION',
					eventname: '로그아웃',
					param: {
						loginmethod: platform,
					},
				};
				enloggingJsonData({
					dataTalkCustom,
				});

				if (returnUrl) {
					goLogin({ returnUrl });
					return;
				}

				goHome();
			} catch (e) {
				console.error(e);
			}
		},
		[enloggingJsonData, getCookie, goLogin, dispatch],
	);
}

export default useLogout;
